module.exports = __webpack_public_path__ + "img/地热国3_1.2b706fe0.png";